export const NavBarHeight = "50px";

export const MonospaceFontFamily =
  '"Platform Emoji", "Source Code Pro", "Consolas", "Monaco", monospace, "Noto Color Emoji", "Apple Color Emoji", "Segoe UI Emoji"';

export const PuzzlePagePadding = "8px";
